import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Instagram, Facebook, Youtube, Linkedin, Zap } from "lucide-react";
import { getCompany } from "@/lib/api";

export default function Footer() {
  const { data: company } = useQuery({
    queryKey: ["company"],
    queryFn: getCompany,
  });

  return (
    <footer
      data-testid="site-footer"
      className="relative mt-24 bg-slate-950 text-slate-400"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-500 text-white">
                <Zap className="h-4 w-4" strokeWidth={2.5} />
              </span>
              <span className="font-heading text-sm tracking-[0.22em] text-white">
                ANANDSAHNI GREEN MOBILITY
              </span>
            </div>
            <p className="mt-6 max-w-md text-sm leading-relaxed">
              {company?.tagline ||
                "Building the next generation of clean, license-free electric two-wheelers for India."}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-emerald-400 font-semibold">
              Navigate
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/" data-testid="footer-link-home" className="hover:text-white">Home</Link></li>
              <li><Link to="/models" data-testid="footer-link-models" className="hover:text-white">Models</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="hover:text-white">About</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-emerald-400 font-semibold">
              Contact
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li data-testid="footer-phone">{company?.phone || "+91 00000 00000"}</li>
              <li data-testid="footer-email">{company?.email || "anandsahnigreenmobility@gmail.com"}</li>
              <li data-testid="footer-address" className="max-w-xs">{company?.address}</li>
            </ul>
            <div className="mt-6 flex items-center gap-3">
              <a
                aria-label="Instagram"
                data-testid="footer-instagram"
                href={company?.social?.instagram || "#"}
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-700 hover:border-emerald-500 hover:text-white"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                aria-label="Facebook"
                data-testid="footer-facebook"
                href={company?.social?.facebook || "#"}
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-700 hover:border-emerald-500 hover:text-white"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                aria-label="YouTube"
                data-testid="footer-youtube"
                href={company?.social?.youtube || "#"}
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-700 hover:border-emerald-500 hover:text-white"
              >
                <Youtube className="h-4 w-4" />
              </a>
              <a
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
                href={company?.social?.linkedin || "#"}
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-700 hover:border-emerald-500 hover:text-white"
              >
                <Linkedin className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {company?.name || "ANANDSAHNI GREEN MOBILITY"}. All rights reserved.
          </p>
          <p className="text-[10px] tracking-[0.3em] uppercase text-slate-600">
            Quietly moving India forward
          </p>
        </div>
      </div>

      <div className="overflow-hidden">
        <p
          aria-hidden
          className="font-heading select-none whitespace-nowrap text-slate-900 text-[14vw] leading-[0.85] font-light tracking-tighter px-2 pb-2"
        >
          ANANDSAHNI
        </p>
      </div>
    </footer>
  );
}
